import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n/config'
import App from './App'
import { sweepStaleServiceWorkers } from './lib/service-workers'

// Kill any service worker registered by previous deploys + clear all caches,
// EXCEPT the Web Push worker. Runs at every boot, idempotent. See
// lib/service-workers.ts for why the exemption is safe for the freshness
// contract, and service-workers.test.ts for the guard that keeps it that way.
sweepStaleServiceWorkers()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
